document.addEventListener('DOMContentLoaded', function () {
  const textContainer = document.querySelector('.metafield-description');

  if (textContainer) {
    document.querySelector('.description-toggle').style.display =
      textContainer.scrollHeight > textContainer.clientHeight ? 'block' : 'none';

    document.querySelector('.description-toggle')?.addEventListener('click', (event) => {
      document
        .querySelector('.collection-hero__description.collection-description')
        .classList.toggle('open-more', event.target.classList.contains('more'));
    });
  }
});
